<template>
	<div id="register_lx">
		<h3 class="color_5babf4 text-center login_title">请选择注册开发者类型</h3>
		<section class="row">
			<div class="col-sm-6 text-center">
				<a href="javascript:void(0);" @click="getparentdata" class="router_link_a" to="/developer_register">
					<img src="./img/icon-individual-developers.png" width="140" alt="" />
					<h4 class="color_f">个人开发者</h4>
					<h5 class="color_9">适用于个人开发者，免费发布应用和开放部分数据接口。</h5>
				</a>
			</div>
			<div class="col-sm-6 text-center">
				<a href="javascript:void(0);" @click="getcompanydata" class="router_link_a" to="/enterprise_developers">
					<img src="./img/icon-enterprise-developers.png" width="140" alt="" />
					<h4 class="color_f">企业开发者</h4>
					<h5 class="color_9">适用于公司、企业、机构等组织注册，可以获得更多的数据接口权限。</h5>
				</a>
			</div>

		</section>
	</div>
</template>

<script>

	export default {
		data() {
			return {
				mob: this.$route.params.mobile
            }
		},
		mounted: function() {
			this.$nextTick(function() {
				if(localStorage.getItem("token") != null) {
					this.queryUser();
					$(".pwdshow").hide();
				}

			})
		},
		methods: {
			getparentdata() {
				var temp = this;
				if(localStorage.getItem("token") != null) {
					this.$router.push({
						name: 'developer_register',
						params: {
							mobile: this.mob
						}
					});
				} else {
					this.$http.post('/zklccloud/weblogin', {
						"username": aesMinEncrypt(this.$route.params.mobile),
						"password": aesMinEncrypt(this.$route.params.password)
					}, {
						emulateJSON: true
					}).then(function(m) {
						localStorage.setItem("token", m.body.access_token);
						localStorage.setItem('loginUserType', "unrole");
						this.$router.push({
							name: 'developer_register',
							params: {
								mobile: this.mob
							}
						});
					});
				}
			},
			getcompanydata() {
				var temp = this;
				if(localStorage.getItem("token") != null) {
					this.$router.push({
						name: 'company_register',
						params: {
							mobile: this.mob
						}
					});
				} else {
					this.$http.post('/zklccloud/weblogin', {
						"username": aesMinEncrypt(this.$route.params.mobile),
						"password": aesMinEncrypt(this.$route.params.password)
					}, {
						emulateJSON: true
					}).then(function(m) {
						localStorage.setItem("token", m.body.access_token);
						localStorage.setItem('loginUserType', "unrole");
						this.$router.push({
							name: 'company_register',
							params: {
								mobile: this.mob
							}
						});
					});
				}
			},
			queryUser() {
				var temp = this;
				this.$http.post('/zklccloud/queryUser',{
					emulateJSON: true
				}).then(function(m) {
					this.mob = m.body.content.mob;
				})
			},
		}
	}
</script>

<style scoped>
	#register_lx {
		min-height: 500px;
	}
	#register_lx h4 {
		margin: 20px 0 20px;
	}

</style>



// WEBPACK FOOTER //
// register_lx.vue?d5aac276